import type { NPSConfig } from "../../lib/types";

type Props = {
  value: NPSConfig;
  onChange: (next: NPSConfig) => void;
};

export const DEFAULT_NPS_CONFIG: NPSConfig = {
  scale: { min: 0, max: 10 },
  labels: { min: "Auf gar keinen Fall", max: "Auf jeden Fall" },
  why_prompt: "Warum diese Bewertung?",
  why_required: false,
};

export function NPSConfigForm({ value, onChange }: Props) {
  function set<K extends keyof NPSConfig>(key: K, v: NPSConfig[K]) {
    onChange({ ...value, [key]: v });
  }
  return (
    <div className="flex flex-col gap-3">
      <label className="flex flex-col gap-1">
        <span className="text-sm text-rc-ink/80">Label „niedrig"</span>
        <input
          value={value.labels.min}
          onChange={(e) => set("labels", { ...value.labels, min: e.target.value })}
          className="rounded-lg border border-rc-ink/10 bg-rc-paper p-2 text-rc-ink focus:outline-none focus:ring-2 focus:ring-rc-berry"
        />
      </label>
      <label className="flex flex-col gap-1">
        <span className="text-sm text-rc-ink/80">Label „hoch"</span>
        <input
          value={value.labels.max}
          onChange={(e) => set("labels", { ...value.labels, max: e.target.value })}
          className="rounded-lg border border-rc-ink/10 bg-rc-paper p-2 text-rc-ink focus:outline-none focus:ring-2 focus:ring-rc-berry"
        />
      </label>
      <label className="flex flex-col gap-1">
        <span className="text-sm text-rc-ink/80">Begründungs-Frage</span>
        <input
          value={value.why_prompt}
          onChange={(e) => set("why_prompt", e.target.value)}
          className="rounded-lg border border-rc-ink/10 bg-rc-paper p-2 text-rc-ink focus:outline-none focus:ring-2 focus:ring-rc-berry"
        />
      </label>
      <label className="flex items-center gap-2 text-sm text-rc-ink/80">
        <input
          type="checkbox"
          checked={value.why_required}
          onChange={(e) => set("why_required", e.target.checked)}
        />
        Begründung verpflichtend
      </label>
    </div>
  );
}
